// components
import { AgreementList } from './AgreementsList';
import { Layouts } from '@commons/components';
import { PosList } from './PosList';
import { NavBar } from './NavBar';
// utils && hooks
import useSettings from './hooks/useSettings';

const Settings = () => {
    const { query, userCanUseCommercialAgreements, active, withoutAgreement, setWithoutAgreements } = useSettings();

    return (
        <Layouts>
            <NavBar
                query={query}
                userCanUseCommercialAgreements={userCanUseCommercialAgreements}
                active={active}
                withoutAgreement={withoutAgreement}
            />

            {active === 'POS' && <PosList />}
            {userCanUseCommercialAgreements() && active === 'trade-agreements' && <AgreementList setWithoutAgreements={setWithoutAgreements}/>}
        </Layouts>
    );
};

export default Settings;
